import React, { Component } from 'react'
import PropTypes from 'prop-types';
import { Link } from 'react-router-dom';
import { Wrapper } from 'modules/theme';
import SettingsSidebar from '../../sidebar';
import { Alert, confirm } from 'modules/theme';
import APIManager from 'modules/common/apiManager';
import { Row, RowTitle, Box, BoxName, Divider } from '../../main/styles';
import { BarItems } from 'modules/theme';
//import { DataWrapperClass } from '../styles';
import { Col, Modal } from 'react-bootstrap';
import { FiTrash2 } from 'react-icons/fi';
import { PerPage } from 'helpers/system-config';
import {
  ModalTrigger,
  Pagination,
  Button,
  FormControl,
  ActionButtons,
  Table,
  Label,
  Tip,
  DataWithLoader,
  FormGroup,
  ControlLabel,
  ReportPagination,
  SeachForm,
  DataWrapperClass,
  ButtonCommonTheme
} from 'modules/theme';
import { leftSidebarType, modalType } from '../../../../../helpers/dotenv';
import AccountAddEdit from './AccountAddEdit';
import { SkillWrapper, TableData } from '../../../../theme/theme1/common/styles/main';

export class Account extends Component {
  constructor(props) {
    super(props);
    this.mAPI = new APIManager();
    this.moduleName = 'Account'
    this.closeModal = this.closeModal.bind(this);
    this.openModal = this.openModal.bind(this);
    // this.onPaginationChange = this.onPaginationChange.bind(this);
    // this.onPerPageChooser = this.onPerPageChooser.bind(this);
    this.state = {
      listData: [],
      loading: false,
      editData: null,
      showHide: false,
      modalType: modalType,
      total: 0,
      currentPage: 1,
      perPageCount: PerPage,
      search: '',
      MasterChecked: false,
      SingleChecked: false,
      SelectedList: [],
      ary: []
    };
  }

  openModal() {
    this.setState({ showHide: true });
  }

  closeModal() {
    this.setState({ showHide: false });
  }

  componentDidMount() {
    this.getList();
  }


  getList() {
    var that = this;
    this.setState({ loading: true });
    this.mAPI.sendGetAPI(
      `tenant/access-key`,
      data => {
        this.setState({ loading: false });
        if (data && data.data) {
          that.setState({ listData: data.data });
        } else {
          that.setState({ listData: [] });
        }
      },
      (error, data) => {
        console.log(`Error:`, error);
        // if (data) {
        //   Alert.success(`${data.message}`);
        // } else {
        //   Alert.error(`${error}`);
        // }
      }
    );
  }

  apiResponse(errorCode, data) {
    if (errorCode === 200) {
      // Alert.success(`${data.message}`);
      let message = data && data.message ? data.message : "Successfully Done";
      Alert.success(message);
    } else {
      // Alert.error(`${data.message}`);
      let message = data && data.message ? data.message : "Something wrong happened";
      Alert.error(message);
    }
  }

  addAccount(e) {
    let _this = this;
    // let email = localStorage.getItem('email');
    e.preventDefault();
    let tData = {

    };
    this.mAPI.sendPostAPI(
      `tenant/initialize`,
      tData,
      data => {
        console.log(JSON.stringify(data, null, 2));
        // window.location.href = '/';
      },
      (errorCode, data) => {
        this.apiResponse(errorCode, data);
      },
      'private',
      '',
      'PATCH'
    );
  }

  renderActionBar() {
    const importTrigger = (
      /*  <Button btnStyle="default" size="small">
         <img src='/images/plus.png' style={{ width: '12px' }} />
       </Button> */
      <ButtonCommonTheme type="add" />
    );
    return (
      <span style={{ display: 'flex', whiteSpace: 'nowrap' }}>

        <ModalTrigger
          title="Account"
          trigger={importTrigger}
          size="md"
          showHide={this.state.showHide}
          closeModal={this.closeModal}
          openModal={this.openModal}
          dialogClassName={this.state.modalType}
        >
          <AccountAddEdit
            size="small"
            update={() => this.setState({ currentPage: 1 })}
            isEdit={false}
            editData={this.state.editData}
            modalType={this.state.modalType}
            closeModal={this.closeModal}
          />
        </ModalTrigger>
      </span>
    );
  }

  render() {
    const { __ } = this.context;
    // const breadcrumb = [
    //   { title: __('Settings'), link: '/settings' },
    //   { title: __('Account'), link: '/settings/account' }
    // ];

    return (
      <div className='heightClass contentData'>
        <DataWrapperClass style={{ height: '100%' }}>
          <SkillWrapper>
            <h2>Auth Tokens & API Keys</h2>
            <Row
              className='topHead'
              style={{
                paddingTop: '0px'
              }}
            >
              <Col>
                <p></p>
              </Col>
              <Col>
                <SeachForm>
                  <FormControl
                    type="text"
                    placeholder={'Search...'}
                    onChange={e => this.search(e)}
                    value={this.state.searchValue}
                    autoFocus={false}
                  />

                </SeachForm>
              </Col>
            </Row>
            <div style={{ background: '#fff', border: '1px solid #d1cccc', borderRadius: '10px', marginTop: '30px', height: '240px', overflowX: 'auto' }}>
              <TableData>
                <div>
                  <ControlLabel>Auth Tokens & API Keys</ControlLabel>
                </div>
                {this.renderActionBar()}
              </TableData>

              <Table bordered hover>
                <thead>
                  <tr>
                    <th>{('name')}</th>
                    <th>{('Token')}</th>
                    <th>{('Date Create')}</th>
                    <th>{('actions')}</th>
                  </tr>
                </thead>
                <tbody>
                  {this.state.listData.map(data => (
                    <tr key={data._id}>
                      <td className="text-primary">{'dhirav'}</td>
                      <td>{'23kapfhwd16mndf'}</td>
                      <td>{'26july'}</td>
                      <td>{'show'}</td>
                    </tr>
                  ))}
                </tbody>
              </Table>
            </div>
          </SkillWrapper>
          {/* header={<Wrapper.Header breadcrumb={breadcrumb} />} */}

        </DataWrapperClass>
      </div>
    );
  }
}

Account.contextTypes = {
  __: PropTypes.func
};

export default Account


// WEBPACK FOOTER //
// src/modules/screens/settings/Account/components/Account.js